/* eslint-disable @nx/enforce-module-boundaries */

import React, { useMemo } from 'react';
import MarkdownPreview from '@uiw/react-markdown-preview';
import { ABodySize, MButton, MButtonSize, MButtonType } from '@marriott/mi-web-ui-kit';
import { MChipGroup } from '../MChipGroup';
import { MResponseActions } from '../MResponseActions';
import * as Styled from './MRedirectLink.styles';
import { MRedirectLinkProps } from './MRedirectLink.types';

export const MRedirectLink: React.FC<MRedirectLinkProps> = ({
  uiData,
  onChipClick,
  messageId,
  thumbFeedback,
  onThumbFeedback,
}) => {
  const intro = typeof uiData?.intro === 'string' ? uiData.intro : '';
  const followUp = typeof uiData?.followUp === 'string' ? uiData.followUp : '';
  const urls = Array.isArray(uiData?.urls) ? uiData.urls : [];
  const chips = Array.isArray(uiData?.mChipGroup?.mQuickSelectChip) ? uiData.mChipGroup!.mQuickSelectChip : [];

  const chipItems = useMemo(
    () =>
      chips.map((chip: { text?: string }) => ({
        aBody: {
          bodyText: chip?.text || '',
          size: ABodySize.S,
        },
        onClick: () => {
          if (chip?.text) {
            onChipClick?.(chip.text);
          }
        },
      })),
    [chips, onChipClick]
  );

  return (
    <Styled.Container>
      {intro && (
        <div className="t-font-s">
          <MarkdownPreview source={intro} />
        </div>
      )}

      {urls.length > 0 && (
        <Styled.UrlList>
          {urls.map((item, idx) => (
            <MButton
              key={idx}
              variant={MButtonType.Secondary}
              size={MButtonSize.S}
              href={item.url}
              target="_blank"
              isExternal
              className="align-self-start"
            >
              {item.text}
            </MButton>
          ))}
        </Styled.UrlList>
      )}

      <MResponseActions
        messageId={messageId}
        thumbFeedback={thumbFeedback}
        onThumbsUp={
          onThumbFeedback
            ? () => {
                if (thumbFeedback) return;
                onThumbFeedback('up');
              }
            : undefined
        }
        onThumbsDown={
          onThumbFeedback
            ? () => {
                if (thumbFeedback) return;
                onThumbFeedback('down');
              }
            : undefined
        }
      />

      {followUp && (
        <div className="t-font-s">
          <MarkdownPreview source={followUp} />
        </div>
      )}

      {chipItems.length > 0 && (
        <Styled.ChipsWrapper>
          <MChipGroup chips={chipItems} variant="chat" />
        </Styled.ChipsWrapper>
      )}
    </Styled.Container>
  );
};

export type { MRedirectLinkProps } from './MRedirectLink.types';
